import { render, staticRenderFns } from "./TaskSelectionComponent.vue?vue&type=template&id=db36e830&scoped=true&"
import script from "./TaskSelectionComponent.vue?vue&type=script&lang=js&"
export * from "./TaskSelectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskSelectionComponent.vue?vue&type=style&index=0&id=db36e830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db36e830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db36e830')) {
      api.createRecord('db36e830', component.options)
    } else {
      api.reload('db36e830', component.options)
    }
    module.hot.accept("./TaskSelectionComponent.vue?vue&type=template&id=db36e830&scoped=true&", function () {
      api.rerender('db36e830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/TaskSelectionComponent.vue"
export default component.exports